<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_login_banner.png')" alt="ログイン方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="sup-page-title">
          ログイン方法
        </h1>
        <div class="sup-steps-box">
          <!-- ステップ 1 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <p class="sup-step-desc">
              ホーム画面の「ログイン」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_1.png')" alt="ステップ1">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 2 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <p class="sup-step-desc">
              ユーザー名とパスワードを入力して「ログイン」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_2.png')" alt="ステップ2">
            </div>
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <!-- 枠タイトル -->
          <p class="sup-steps-box-title">
            ※パスワードをお忘れの場合※
          </p>

          <!-- ステップ 1 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <p class="sup-step-desc">
              ログイン画面の「パスワードをお忘れの場合」を選択
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_3.png')" alt="パスワード忘れ ステップ1">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 2 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <p class="sup-step-desc">
              ユーザー名とメールアドレスを入力し、「送信する」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_4.png')" alt="パスワード忘れ ステップ2">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 3 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-desc">
              登録のメールアドレスに届いた「認証コード」を確認
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_5.png')" alt="パスワード忘れ ステップ3">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 4 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 4
            </p>
            <p class="sup-step-desc">
              受信した認証コードを入力し、「認証」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_6.png')" alt="パスワード忘れ ステップ4">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 5 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 5
            </p>
            <p class="sup-step-desc">
              新しいパスワードを設定し、<br>「送信する」をタップすると再設定完了
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_login_7.png')" alt="パスワード忘れ ステップ5">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'login',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
